<template>
    <form class="selector">
        <div class="form-group form-group-selectr">
            <label for="investor">Investor</label>

            <select id="investor" class="form-control" name="investor" v-model="value" @change.stop="update($event)">
                <option v-for="option in options" :value="option.id" v-html="option.value"></option>
            </select>
        </div>
    </form>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget.vue';

    export default {
        extends: VisibleSelectorWidget,
        created() {
            this.render();
        },
        methods: {
            broadcast(value) {
                window.events.emit('updateInvestor', parseInt(value));
            }
        }
    }
</script>
